import React, {
  useEffect,
  useState,
  useReducer,
  useContext,
  useRef,
} from "react";
import moment from "moment";
import axios from "axios";

import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";

import { UserContext } from "../UserContext";

const {
  REACT_APP_ECLIPSE_API_PUBLIC,
  REACT_APP_ECLIPSE_API,
  REACT_APP_ECLIPSE_API_Local,
} = process.env;

const filter = createFilterOptions();

export default function FreeSoloCreateOptionDialog({
  setAC_SelectedData_Item,
  C_Title,
}) {
  // --------------------------------------- use context
  const contextValue = useContext(UserContext);

  // ------------------------------------------------- DB

  //
  const [DB_ItemList, setDB_ItemList] = useState([]);
  const get_DB_Item_List = () => {
    axios
      .post(`${REACT_APP_ECLIPSE_API}/get_vlerp__item__all`)
      .then((res) => {
        setDB_ItemList(res.data);
        console.log("get_DB_Item_List", res.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  //
  const add_DB_Item_List = (
    _item_name,
    _item_desc,
    _item_price_cost,
    _item_price_srp,
    _item_gen_by
  ) => {
    axios
      .post(`${REACT_APP_ECLIPSE_API}/add_vlerp__item`, {
        item_name: _item_name,
        item_desc: _item_desc,
        item_price_cost: _item_price_cost,
        item_price_srp: _item_price_srp,
        item_gen_by: _item_gen_by,
      })
      .then((res) => {
        setDB_ItemList(res.data);
        console.log("add_DB_Item_List", res.data);
        if (res.data.affectedRows > 0) {
          alert("New Item Add Successfully ! ");

          setTimeout(() => {
            get_DB_Item_List();
            handleClose();
          }, 2000);
        } else {
          alert("Failed to Add New Item, Please contact Admin !");
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  // ------------------------------------------------- etc

  const [value, setValue] = React.useState(null);
  const [open, toggleOpen] = React.useState(false);

  const handleClose = () => {
    setDialogValue({
      item_name: "",
      item_desc: "",
    });

    toggleOpen(false);
  };

  const [dialogValue, setDialogValue] = React.useState({
    item_name: "",
    item_desc: "",
  });

  const handleSubmit = (event) => {
    console.log("hit");
    event.preventDefault();
    setValue({
      referer_id: selected_RefererID.current,
      item_name: dialogValue.item_name,
      item_desc: dialogValue.item_desc,
    });

    // // update parent
    setAC_SelectedData_Item({
      item_name: dialogValue.item_name,
      item_desc: dialogValue.item_desc,
    });

    // add to db
    add_DB_Item_List(
      dialogValue.item_name,
      dialogValue.item_desc,
      dialogValue.item_price_cost,
      dialogValue.item_price_srp,
      contextValue.current.firebase_userInfo.email
    );
  };

  // ------------------------------------------------- Global Variable
  const selected_RefererID = useRef("NA");

  // ------------------------------------------------- useEffect

  useEffect(() => {
    get_DB_Item_List();
  }, []);

  return (
    <React.Fragment>
      <Autocomplete
        value={value}
        onChange={(event, newValue) => {
          if (typeof newValue === "string") {
            // timeout to avoid instant validation of the dialog's form.
            setTimeout(() => {
              toggleOpen(true);
              setDialogValue({
                item_name: newValue,
                item_desc: "",
              });
              setAC_SelectedData_Item({
                item_name: newValue,
                item_desc: "",
              });
            });
          } else if (newValue && newValue.inputValue) {
            toggleOpen(true);
            setDialogValue({
              item_name: newValue.inputValue,
              item_desc: "",
            });
            setAC_SelectedData_Item({
              item_name: newValue.inputValue,
              item_desc: "",
            });
          } else {
            setValue(newValue);
            setAC_SelectedData_Item(newValue);
          }
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          if (params.inputValue !== "") {
            filtered.push({
              inputValue: params.inputValue,
              item_name: `Add "${params?.inputValue}"`,
            });
          }

          return filtered;
        }}
        id="free-solo-dialog-demo"
        options={DB_ItemList}
        getOptionLabel={(option) => {
          // e.g value selected with enter, right from the input
          // console.log("option", option.id);
          selected_RefererID.current = option.id;
          if (typeof option === "string") {
            return option;
          }
          if (option.inputValue) {
            return option.inputValue;
          }
          return option.id == undefined
            ? option.item_name
            : "(" + option.id + ") " + option.item_name;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        renderOption={(props, option) => (
          <li {...props}>
            <div>
              <div>{`(${option?.id}) ${option?.item_name}`}</div>
              <div>{`ref : ${option?.item_desc}`}</div>
            </div>
          </li>
        )}
        sx={{ width: "100%" }}
        freeSolo
        renderInput={(params) => <TextField {...params} label={C_Title} />}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        // fullScreen
        fullWidth={true}
        maxWidth="xl"
      >
        <form onSubmit={handleSubmit}>
          <DialogTitle>Add a new Referer</DialogTitle>
          <DialogContent>
            <DialogContentText>..</DialogContentText>

            <div className="global_flex_column_cc gap_50">
              <TextField
                fullWidth
                autoFocus
                margin="dense"
                id="name"
                value={dialogValue.item_name.split(")")[1]}
                onChange={(event) =>
                  setDialogValue({
                    ...dialogValue,
                    item_name: event.target.value,
                  })
                }
                label="Item Name"
                type="text"
                variant="standard"
              />
              <TextField
                fullWidth
                margin="dense"
                id="name"
                value={dialogValue.item_desc}
                onChange={(event) =>
                  setDialogValue({
                    ...dialogValue,
                    item_desc: event.target.value,
                  })
                }
                label="Item Desc"
                type="text"
                variant="standard"
              />
              <TextField
                fullWidth
                margin="dense"
                id="name"
                value={dialogValue.item_price_cost}
                onChange={(event) =>
                  setDialogValue({
                    ...dialogValue,
                    item_price_cost: event.target.value,
                  })
                }
                label="Item Cost"
                type="text"
                variant="standard"
              />
              <TextField
                fullWidth
                margin="dense"
                id="name"
                value={dialogValue.item_price_srp}
                onChange={(event) =>
                  setDialogValue({
                    ...dialogValue,
                    item_price_srp: event.target.value,
                  })
                }
                label="Item Cost"
                type="text"
                variant="standard"
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="submit">Add</Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
const sampleData = [
  { title: "The Shawshank Redemption", item_desc: 1994 },
  { title: "The Godfather", item_desc: 1972 },
];
